var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "img-uploader" },
    [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: { click: _vm.quitar }
        },
        [_c("i", { staticClass: "fa fa-times" })]
      ),
      _vm._v(" "),
      _c("img", {
        staticStyle: { cursor: "pointer" },
        attrs: {
          width: "100%",
          height: "200px;",
          id: _vm.id,
          src: _vm.srcImage,
          alt: _vm.alt
        },
        on: { dblclick: _vm.verImagen }
      }),
      _vm._v(" "),
      _c("center", [
        _c("input", {
          ref: "file" + _vm.id,
          staticClass: "mb-2",
          attrs: { type: "file", id: "file" + _vm.id },
          on: { change: _vm.changeImagen }
        })
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "imageViewer" + _vm.id,
            scrollable: "",
            resizable: "",
            adaptive: "",
            reset: "",
            width: "75%",
            height: "auto"
          }
        },
        [_c("image-viewer", { attrs: { file: _vm.value } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43e99cfc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43e99cfc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/visitas/ImageUploader.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-43e99cfc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/visitas/ImageUploader.vue
// module chunks = 0